module.exports = __webpack_public_path__ + "static/media/mini-reports.00c0c51e.svg";